import { isNullOrUndefined } from "@utils/common";
import { api } from "@/api";
import {
  type IMunicipalitiesResponse,
  type IMunicipality,
  type ISettlement,
  type ISettlementsResponse,
  type IStreet,
  type IStreetsResponse,
} from "./types";

export const getMunicipalities = async (
  countryCode?: string,
): Promise<IMunicipality[]> =>
  (
    await api.get<IMunicipalitiesResponse>(
      `/adresses/municipalities${
        !isNullOrUndefined(countryCode) ? `?countryCode=${countryCode}` : ""
      }`,
    )
  ).data.municipalities;

export const getSettlements = async (
  municipalityId: IMunicipality["municipalityId"],
  countryCode?: string,
): Promise<ISettlement[]> =>
  (
    await api.get<ISettlementsResponse>(
      `/adresses/municipalities/${municipalityId}/settlements${
        !isNullOrUndefined(countryCode) ? `?countryCode=${countryCode}` : ""
      }`,
    )
  ).data.settlements;

export const getStreets = async (
  municipalityId: IMunicipality["municipalityId"],
  settlementId: ISettlement["settlementId"],
  countryCode?: string,
): Promise<IStreet[]> =>
  (
    await api.get<IStreetsResponse>(
      `/adresses/municipalities/${municipalityId}/settlements/${settlementId}/streets${
        !isNullOrUndefined(countryCode) ? `?countryCode=${countryCode}` : ""
      }`,
    )
  ).data.streets;
